import { render, staticRenderFns } from "./BillingGrid.vue?vue&type=template&id=b389d80a&scoped=true"
import script from "./BillingGrid.vue?vue&type=script&lang=js"
export * from "./BillingGrid.vue?vue&type=script&lang=js"
import style0 from "./BillingGrid.vue?vue&type=style&index=0&id=b389d80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b389d80a",
  null
  
)

export default component.exports